// TODO PP-16776: move LoggedInWeb/utils/is-function here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/utils/is-function';
